import { useAccountTypes } from '../providers'

export const useBreakdownEligibility = (
  hasBreakdownWidgetAdded?: boolean,
): boolean => {
  const {
    groupedAccounts,
    totalBalanceOfBankAndInvest,
    isMortgageOnlyUser,
    isPartialOutage,
  } = useAccountTypes()

  // If the user becomes ineligible due to an outage but has the widget added we still want to show the widget and display an error inside of it.
  if (hasBreakdownWidgetAdded && isPartialOutage) {
    return true
  }
  const greaterThanZeroTotal = !!(
    totalBalanceOfBankAndInvest && totalBalanceOfBankAndInvest > 0
  )

  // Check if only one account type
  const allAccountsArray = Object.values(groupedAccounts)
  const allSameType = allAccountsArray.every(account => {
    return account.accountGroup === allAccountsArray[0].accountGroup
  })

  // Check if any account type total is negative
  const groupedAccountsArray = Object.values(groupedAccounts).map(
    account => account.aggBalance,
  )
  const noNegBalance = groupedAccountsArray.every(total => total >= 0)

  return (
    greaterThanZeroTotal && !allSameType && !isMortgageOnlyUser && noNegBalance
  )
}
